// @file: client/src/components/MentionMappingRow.jsx

export default function MentionMappingRow({ guild, displayName, onRemove }) {
  return (
    <div className="mention-mapping-row">
      {/* ── Desktop: inline chips with arrow ── */}
      <div className="mention-desktop">
        <div className="mention-chip">
          <div className="mention-chip-icon">
            {guild.icon ? (
              <img
                src={`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png`}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            ) : (
              <span className="mention-chip-icon-fallback">
                {(guild.name || "??").substring(0, 2)}
              </span>
            )}
          </div>
          <span className="mention-chip-label mention-chip-label--server">
            {guild.name}
          </span>
        </div>

        <svg
          className="mention-arrow"
          width={12} height={12}
          fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round"
          viewBox="0 0 24 24" aria-hidden="true"
        >
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>

        <div className="mention-chip">
          <span className="mention-chip-label mention-chip-label--model">
            {displayName || "—"}
          </span>
        </div>
      </div>

      {/* ── Mobile: icon | stacked text | x ── */}
      <div className="mention-mobile">
        <div className="mention-chip-icon">
          {guild.icon ? (
            <img
              src={`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png`}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          ) : (
            <span className="mention-chip-icon-fallback">
              {(guild.name || "??").substring(0, 2)}
            </span>
          )}
        </div>

        <div className="mention-mobile-text">
          <span className="mention-chip-label mention-chip-label--server">
            {guild.name}
          </span>
          <span className="mention-chip-label mention-chip-label--model">
            {displayName || "—"}
          </span>
        </div>

        <button
          type="button"
          className="mention-remove-btn"
          onClick={onRemove}
          title="Remove mapping"
          aria-label={`Remove mapping for ${guild.name}`}
        >
          <svg width={12} height={12} fill="none" stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* ── Desktop remove ── */}
      <button
        type="button"
        className="mention-remove-btn mention-remove-desktop"
        onClick={onRemove}
        title="Remove mapping"
        aria-label={`Remove mapping for ${guild.name}`}
      >
        <svg width={12} height={12} fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
